import React from 'react'

export default function Fleet() {
  return (
    <div>Fleet</div>
  )
}
